import axios from "axios";
import { adminApi, sellerApi } from "./api";

export const getPlatformStatsApi = () =>
  axios.get(`${process.env.VUE_APP_API_URL}/api/v1/admin/platform-stats`);

export const getAdminUsersApi = async () => {
  const res = await adminApi.get("/api/v1/admin/users");
  return res.data;
};

export const getAdminsApi = async () => {
  const res = await adminApi.get("/api/v1/auth/admins");
  return res.data;
};

export const updateAdminUserStatusApi = async (userId, status) => {
  const res = await adminApi.put(`/api/v1/admin/users/${userId}/status`, {
    status,
  });
  return res.data;
};

export const updateAdminProfileApi = async (payload) => {
  const res = await adminApi.put("/api/v1/auth/admin/profile", payload);
  return res.data;
};

export const updateAdminProfileImageApi = async (fileOrUrl) => {
  const formData = new FormData();

  if (fileOrUrl instanceof File) {
    formData.append("profileImage", fileOrUrl);
  } else if (typeof fileOrUrl === "string") {
    formData.append("profileImage", fileOrUrl);
  }

  const res = await adminApi.put("/api/v1/auth/admin/profile/image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
};

export const updateAdminPasswordApi = async (payload) => {
  const res = await adminApi.put("/api/v1/auth/admin/password", payload);
  return res.data;
};

// --- Shipping Companies ---
export const getShippingCompaniesApi = async () => {
  const res = await adminApi.get("/api/v1/vehicleType");
  return res.data;
};

export const getShippingCompaniesApiSeller = async () => {
  const res = await sellerApi.get("/api/v1/vehicleType");
  return res.data;
};

export const createVehicleTypeApi = async (payload) => {
  const res = await adminApi.post("/api/v1/vehicleType", payload);
  return res.data;
};

export const updateVehicleTypeApi = async (id, payload) => {
  const res = await adminApi.put(`/api/v1/vehicleType/${id}`, payload);
  return res.data;
};

// --- Ships (Master Shipping) ---
export const getShipsApi = async () => {
  const res = await adminApi.get("/api/v1/ships");
  return res.data;
};

// --- Dashboard ---
export const getAdminDashboardStatsApi = async () => {
  const res = await adminApi.get("/api/v1/admin/dashboard/stats");
  return res.data;
};

export const getAdminTopProductsApi = async (limit = 10) => {
  const res = await adminApi.get("/api/v1/admin/dashboard/top-products", {
    params: { limit },
  });
  return res.data;
};

export const getAdminRecentOrdersApi = async (limit = 10) => {
  const res = await adminApi.get("/api/v1/admin/dashboard/recent-orders", {
    params: { limit },
  });
  return res.data;
};

export const getAdminOrderStatusApi = async () => {
  const res = await adminApi.get("/api/v1/admin/dashboard/order-status");
  return res.data;
};

export const getAdminMonitorLocationsApi = async () => {
  const res = await adminApi.get("/api/v1/admin/dashboard/monitor-locations");
  return res.data;
};

// สรุปงานค้างที่ต้องดำเนินการ (การแจ้งเตือน admin)
export const getAdminNotificationsApi = async () => {
  const res = await adminApi.get("/api/v1/admin/dashboard/notifications");
  return res.data;
};

// --- Rider Service Types ---
export const getRiderServiceTypesApi = async () => {
  const res = await adminApi.get("/api/v1/rider-service-type");
  return res.data;
};

export const createRiderServiceTypeApi = async (payload) => {
  const res = await adminApi.post("/api/v1/rider-service-type", payload);
  return res.data;
};

export const updateRiderServiceTypeApi = async (id, payload) => {
  const res = await adminApi.put(`/api/v1/rider-service-type/${id}`, payload);
  return res.data;
};

export const deleteRiderServiceTypeApi = async (id) => {
  const res = await adminApi.delete(`/api/v1/rider-service-type/${id}`);
  return res.data;
};

export const seedRiderServiceTypesApi = async () => {
  const res = await adminApi.post("/api/v1/rider-service-type/seed");
  return res.data;
};

// --- Rider Service Configs (Pricing) ---
export const getRiderServiceConfigsApi = async () => {
  const res = await adminApi.get("/api/v1/rider-service-config");
  return res.data;
};

export const getRiderServiceConfigByIdApi = async (id) => {
  const res = await adminApi.get(`/api/v1/rider-service-config/${id}`);
  return res.data;
};

export const createRiderServiceConfigApi = async (payload) => {
  const res = await adminApi.post("/api/v1/rider-service-config", payload);
  return res.data;
};

export const updateRiderServiceConfigApi = async (id, payload) => {
  const res = await adminApi.put(`/api/v1/rider-service-config/${id}`, payload);
  return res.data;
};

export const deleteRiderServiceConfigApi = async (id) => {
  const res = await adminApi.delete(`/api/v1/rider-service-config/${id}`);
  return res.data;
};

export const seedRiderServiceConfigsApi = async () => {
  const res = await adminApi.post("/api/v1/rider-service-config/seed");
  return res.data;
};

export const calculateRiderPriceApi = async (vehicleTypeId, serviceTypeId, distance) => {
  const res = await adminApi.get("/api/v1/rider-service-config/calculate", {
    params: { vehicleTypeId, serviceTypeId, distance },
  });
  return res.data;
};

// --- Rider Service Config Add-Ons ---
export const getAddonsApi = async (configId) => {
  const res = await adminApi.get(`/api/v1/rider-service-config/${configId}/addons`);
  return res.data;
};

export const createAddonApi = async (configId, payload) => {
  const res = await adminApi.post(`/api/v1/rider-service-config/${configId}/addons`, payload);
  return res.data;
};

export const updateAddonApi = async (configId, addonId, payload) => {
  const res = await adminApi.put(`/api/v1/rider-service-config/${configId}/addons/${addonId}`, payload);
  return res.data;
};

export const deleteAddonApi = async (configId, addonId) => {
  const res = await adminApi.delete(`/api/v1/rider-service-config/${configId}/addons/${addonId}`);
  return res.data;
};

// --- Penalty Settings (พักเงิน rider เปิด/ปิด ตามหมวด + ประเภทรถ) ---
export const getPenaltySettingsApi = async () => {
  const res = await adminApi.get("/api/v1/penalty-setting");
  return res.data;
};

export const updatePenaltySettingsApi = async (items) => {
  const res = await adminApi.put("/api/v1/penalty-setting", { items });
  return res.data;
};